'use client';
import { configureStore } from '@reduxjs/toolkit'
import freelancerSlice from './Features/freelancerSlice';

export const store = configureStore({
    reducer: {
        freelancer: freelancerSlice
    }
  })